import { render, staticRenderFns } from "./PeppolEndpointsEditor.vue?vue&type=template&id=3e8c0cb3&scoped=true"
import script from "./PeppolEndpointsEditor.vue?vue&type=script&lang=ts"
export * from "./PeppolEndpointsEditor.vue?vue&type=script&lang=ts"
import style0 from "./PeppolEndpointsEditor.vue?vue&type=style&index=0&id=3e8c0cb3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e8c0cb3",
  null
  
)

export default component.exports